(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('image-popup')) return;

    customElements.define('image-popup', class extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'theme:' + this.id + ':dismissed';
        this.onlyOnce = this.hasAttribute('only-once');
        this.delay = (parseFloat(this.getAttribute('apparition-delay')) || 0) * 1000;
        this._onKey = (event) => { if (event.key === 'Escape') this.close(); };

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-popup-close]')) {
            event.preventDefault();
            this.close();
          }
        });

        // Theme editor: open when the section is selected, close on deselect.
        if (this.hasAttribute('handle-editor-events') && window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open();
          });
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.close();
          });
          return;
        }

        if (this.onlyOnce && localStorage.getItem(this.storageKey)) return;
        this.timer = setTimeout(() => this.open(), this.delay);
      }

      open() {
        this.setAttribute('open', '');
        document.addEventListener('keydown', this._onKey);
      }

      close() {
        clearTimeout(this.timer);
        this.removeAttribute('open');
        document.removeEventListener('keydown', this._onKey);
        if (this.onlyOnce) {
          try { localStorage.setItem(this.storageKey, 'true'); } catch (e) {}
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
